'use client';

import React from 'react';
import dynamic from 'next/dynamic';

import { Container } from '@/components/Container';
import { FullArticle } from '@/components/FullArticle/FullArticle';
import { AdditionalPaddings } from '@/components/Layouts/AdditionalPadding';
import { BlogLayout } from '@/components/Layouts/BlogLayout';
import { FeaturesLayout } from '@/components/Layouts/FeaturesLayout';
import Section from '@/components/Section/Section';
import { ArticlesList } from '@/features/ArticlesList/ArticlesList';
import { Banner } from '@/features/Banner/Banner';
import { BookDemo } from '@/features/BookDemo/BookDemo';
import { ExploreTools } from '@/features/ExploreTools/ExploreTools';
import { FAQ } from '@/features/FAQ/FAQ';
import { FeaturesIntro } from '@/features/FeaturesIntro/FeaturesIntro';
import { Testimonals } from '@/features/Testimonals/Testimonals';
// import { WorkFlowV2 } from '@/features/WorkFlow/WorkFlowV2';
import {
  articles,
  blog,
  bookDemo,
  explore,
  faq,
  fullArticle1,
  fullArticle2,
  intro,
  testimonals,
} from '@/lib/features/gps_tracking';

const BlogDynamic = dynamic(() => import('@/features/Blog/Blog'), {
  ssr: false,
});

const TimeTracking = () => {
  return (
    <>
      <FeaturesIntro {...intro} />

      {/* <WorkFlowV2 /> */}

      <Section>
        <Container>
          <FullArticle revert={true} item={fullArticle2} />
        </Container>
      </Section>

      <Container>
        <Section title={articles.title}>
          <ArticlesList {...articles} />
        </Section>
      </Container>

      <Section>
        <AdditionalPaddings>
          <Banner
            subTitle="Be Sure to Get the Best Employee GPS Tracking!"
            title={`Improve the productivity of your employees with Orcatec’s GPS tracking software`}
            secondaryTitle=""
            listItems={[]}
          />
        </AdditionalPaddings>
      </Section>

      <Section>
        <Container>
          <FullArticle revert={false} item={fullArticle1} />
        </Container>
      </Section>

      <Section>
        <Container>
          <ExploreTools {...explore} />
        </Container>
      </Section>

      <FeaturesLayout>
        <Section>
          <Banner
            subTitle="Find out what other tools are available to you."
            title={`Free and easy access to the best Orcatec products`}
            secondaryTitle=""
            listItems={[]}
          />
        </Section>

        <Section>
          <Container>
            <Testimonals {...testimonals} />
          </Container>
        </Section>

        <Container>
          <Section title={faq.title}>
            <FAQ {...faq} />
          </Section>
        </Container>
      </FeaturesLayout>

      <BlogLayout>
        <Container>
          <Section title={blog.title} description={blog.description}>
            <BlogDynamic />
          </Section>
        </Container>
      </BlogLayout>

      <BookDemo {...bookDemo} />
    </>
  );
};

export default TimeTracking;
